// 判断是否是微信环境
export const isWexinFn = () => {
  const userAgent = navigator.userAgent; // 获取User Agent字符串
  if (/micromessenger/i.test(userAgent)) {
    console.log('微信环境');
    return true; // User Agent中包含了"MicroMessenger"关键词，说明是微信环境
  } else {
    console.log('非微信环境');
    return false; // 非微信环境
  }
}